<template>
  <div class="user-avatar-dropdown">
    <Dropdown @on-click="handleClick">
      <a href="javascript:void(0)">
       {{ userName }}
       <Icon :size="18" type="md-arrow-dropdown"></Icon>
      </a>
      <Badge :count="messageUnreadCount" class="user-badge">
        <Avatar size="large" shape="square"  :src="userAvatar"/>
      </Badge>
      <DropdownMenu slot="list">
        <DropdownItem name="ownSpace">
          个人中心
        </DropdownItem>
        <DropdownItem name="message">
          消息中心<Badge style="margin-left: 10px" :count="messageUnreadCount"></Badge>
        </DropdownItem>
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>
<script>
import './user.less'
import { mapActions } from 'vuex'
export default {
  name: 'User',
  props: {
    userAvatar: {
      type: String,
      default: ''
    },
    messageUnreadCount: {
      type: Number,
      default: 0
    },
    userName: {
      type: String,
      default: ''
    }
  },
  methods: {
    ...mapActions([
      'handleLogOut'
    ]),
    logout () {
      this.handleLogOut().then((res) => {
        this.$router.push({
          name: 'login'
        })
        const message = res.data.message
        this.$Message.success(message)
      })
    },
    message () {
      this.$router.push({
        name: 'message_page'
      })
    },
    ownSpace () {
      this.$router.push({
        name: 'ownspace'
      })
    },
    handleClick (name) {
      switch (name) {
        case 'logout': this.logout()
          break
        case 'message': this.message()
          break
        case 'ownSpace': this.ownSpace()
          break
      }
    }
  }
}
</script>
<style lang="less">
  .user-badge{
    .ivu-badge-count{
      top: 6px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/components/user/user.vue